import * as angular from 'angular';
import 'angular-ladda';
import 'angular-spinner';
import 'angular-moment';
import 'angular-resizable';
import 'checklist-model';
import 'angular-auto-validate/dist/jcs-auto-validate.min';
import 'isteven-angular-multiselect/isteven-multi-select';
import 'angular-local-storage';
import 'angular-elastic';
import 'angular-animate';
import 'angular-aria';
import './services/ngClickCopy';
import 'angular-cookies';
import 'ng-dialog';
import 'ngmap';
import 'angular-material';
import 'angular-messages';
import 'angular-sanitize';
import 'angular-toastr';
import 'angular-ui-bootstrap';
import 'angular-ui-router';
import 'angular-ui-sortable';
import 'v-accordion';

const libs = [
  'pims.constants',
  'ngMaterial',
  'ngAnimate',
  'ngCookies',
  'ngSanitize',
  'ngMessages',
  'ngAria',
  'ui.router',
  'ui.bootstrap',
  'ui.sortable',
  'angular-ladda',
  'isteven-multi-select',
  'toastr',
  'jcs-autoValidate',
  'LocalStorageModule',
  'vAccordion',
  'angularSpinner',
  'angularMoment',
  'ngDialog',
  'angularResizable',
  'ngMap',
  'checklist-model',
  'monospaced.elastic',
  'ngClickCopy',
];

export default angular.module('pims', libs);
